import { Injectable, Injector } from '@angular/core';
import { BaseState } from "src/app/common/base/base.state";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { ActionItemsCreate, ActionItemsDelete, ActionItemsRefresh, ActionItemsUpdate, ActionItemsUpdateByForm, ActionItemsUpdateBySection } from "./actionItems.action";
import { ActionItem } from "src/app/common/models/action-item";
import { ActionItemService } from "../action-item.service";
import { utils } from "src/app/modules/libs/utils";
import { FormType } from "src/app/common/enumerations/enumerations";

export class ActionItemsStateModel {
  data: ActionItem[] = [];
}

@State<ActionItemsStateModel>({
  name: 'ActionItems',
  defaults: {
    data: [],
  }
})
@Injectable()
export class ActionItemsState extends BaseState {
  constructor(
    protected override injector: Injector,
    private ActionItemsService: ActionItemService

  ) {
    super(injector);
  }

  @Selector()
  static read(state: ActionItemsStateModel) {
    return state.data;
  }

  @Action(ActionItemsRefresh)
  refresh({ patchState }: StateContext<ActionItemsStateModel>, { AbsiId }: ActionItemsRefresh) {
    if (AbsiId) {
      this.ActionItemsService.readByForm(FormType.ABSI, AbsiId).subscribe(
        data => patchState({ data }),
        error => console.error(error)
      );
    }
    else {
      patchState({ data: [] });
    }
  }

  @Action(ActionItemsCreate)
  create({ getState, patchState }: StateContext<ActionItemsStateModel>, { item }: ActionItemsCreate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(item.id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
    else {
      patchState({ data: [...state.data, item] });
    }
  }

  @Action(ActionItemsUpdate)
  update({ getState, patchState }: StateContext<ActionItemsStateModel>, { id, item }: ActionItemsUpdate) {
    const state = getState();
    const index = state.data.map(x => x.id).indexOf(id);

    if (index >= 0) {
      state.data.splice(index, 1);
      patchState({
        data: [...state.data, item]
      });
    }
  }

  @Action(ActionItemsUpdateBySection)
  updateBySection({ getState, patchState }: StateContext<ActionItemsStateModel>, { sectionID, items }: ActionItemsUpdateBySection) {
    const state = getState();
    const data = utils.cloneDeep(state.data.filter(a => a.wfSectionId != sectionID).concat(items));
    patchState({ data });
  }

  @Action(ActionItemsUpdateByForm)
  updateByForm({ getState, patchState }: StateContext<ActionItemsStateModel>, { type, formID, items }: ActionItemsUpdateByForm) {
    const state = getState();
    const data = utils.cloneDeep(state.data.filter(a => a.formType == type && a.formId == formID).concat(items));
    patchState({ data });
  }

  @Action(ActionItemsDelete)
  delete({ getState, patchState }: StateContext<ActionItemsStateModel>, { id }: ActionItemsDelete) {
    patchState({
      data: getState().data.filter(x => x.id != id)
    });
  }


}
